import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { KeyValue } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

export class ColCatService {

  constructor(public http: HttpClient) {}

  public getCollections() {
    return this.http.get('/assets/meta-data/col-cat.json').pipe(map((data: any[]) => data['collections']));
  }

  public subCollection() {
    return this.http.get('/assets/meta-data/col-cat.json').pipe(map((data: any[]) => data['subCollections']));
  }

  public category() {
    return this.http.get('/assets/meta-data/col-cat.json').pipe(map((data: any[]) => data['categories']));
  }

  public subCategory() {
    return this.http.get('/assets/meta-data/col-cat.json').pipe(map((data: any[]) => data['subCategories']));
  }

  valueOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
    return a.value.localeCompare(b.value);
  }

}
